import axiosClient from './axiosClient';

export default {

  create: (data) =>
    axiosClient.post('/anni-fiscali', data),

  update: (id, data) =>
    axiosClient.put(`/anni-fiscali/${id}`, data),

  delete: (id) =>
    axiosClient.delete(`/anni-fiscali/${id}`),

  getById: (id) =>
    axiosClient.get(`/anni-fiscali/${id}`),

  getByContribuente: (contribuenteId) =>
    axiosClient.get(`/anni-fiscali/contribuente/${contribuenteId}`),

  getPaginated: (params) =>
    axiosClient.get('/anni-fiscali/paginated', { params })

};